import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['form'];

  showForm(e) {
    e.preventDefault()
    e.target.remove()
    this.formTarget.classList.remove('hide')
    return false;
  }
}
